<template>
	<div id='setBasicInfo'>
		<el-row class="row">
			<el-col :span="3">
				网页版使用链接
			</el-col>
			<el-col :span="21">
				<a :href="H5_link">{{H5_link}}</a>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				引用模块代码
			</el-col>
			<el-col :span="21">
				<div id="code-div">
					<pre id='code-to-be-copied'>
&lt;script src=&quot;https://unpkg.com/vue&quot;&gt;&lt;/script&gt;
&lt;script src=&quot;https://www.id-photo-verify.com/edu/leqistandardh5.umd.js&quot;&gt;&lt;/script&gt;
&lt;link rel=&quot;stylesheet&quot; href=&quot;https://www.id-photo-verify.com/edu/leqistandardh5.css&quot;&gt;
&lt;div id=&quot;app&quot;&gt;
  &lt;leqistandardh5 app_secret=&#x27;{{app_info.webapp_key}}&#x27;&gt;&lt;/leqistandardh5&gt;
&lt;/div&gt;
&lt;script&gt;
new Vue({
  components: {
    leqistandardh5
  }
}).$mount(&#x27;#app&#x27;)
&lt;/script&gt;
					</pre>
				</div>
				<button id='copy-button' ref="copy" data-clipboard-target="#code-to-be-copied" @click="copyCode">复制代码</button>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				app_key
			</el-col>
			<el-col :span="21">
				唯一app_key:{{app_info.webapp_key}}
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				微信支付
			</el-col>
			<el-col :span="15">
				<div>{{app_info.wechat_app_id&&
					app_info.wechat_api_key&&
					app_info.wechat_mch_id?'已设置':'未设置'}}</div>
			</el-col>
			<el-col :span="6">
				<el-button type="primary" @click='wxShow = true'>修改微信支付参数</el-button>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				支付宝支付
			</el-col>
			<el-col :span="15">
				<div>{{app_info.alipay_app_id&&
					app_info.alipay_public_key&&
					app_info.alipay_private_key?'已设置':'未设置'}}</div>
			</el-col>
			<el-col :span="6">
				<el-button type="primary" @click='alipayShow = true'>修改支付宝支付参数</el-button>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				证件照制作价格
			</el-col>
			<el-col :span="15">
				{{app_info.ele_price}}元
			</el-col>
			<el-col :span="6">
				<el-button type="primary" @click='priceAndTelShow = true'>修改价格和客服电话</el-button>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				证件照制作并换正装价格
			</el-col>
			<el-col :span="15">
				{{app_info.clothes_price}}元
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="3">
				客服电话号码
			</el-col>
			<el-col :span="15">
				{{app_info.service_phone}}
			</el-col>
		</el-row>
		<el-dialog :visible.sync="priceAndTelShow" title='修改价格和客服电话'>
			<el-form label-position='left' ref="form" :model="app_info" label-width="200px" size="mini">
				<el-form-item label="证件照制作价格">
					<el-input v-model="temp_ele_price"></el-input>
				</el-form-item>
				<el-form-item label="证件照制作并换正装价格">
					<el-input v-model="temp_clothes_price"></el-input>
				</el-form-item>
				<el-form-item label="客服电话号码">
					<el-input v-model="app_info.service_phone"></el-input>
				</el-form-item>
				<el-button @click='submit'>提交</el-button>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="alipayShow" title='修改支付宝支付参数'>
			<el-form label-position='left' ref="form2" :model="alipayParam" label-width="200px" size="mini">
				<el-form-item label="app id">
					<el-input v-model="alipayParam.alipay_app_id"></el-input>
				</el-form-item>
				<el-form-item label="支付宝公钥">
					<el-input v-model="alipayParam.alipay_public_key" type="textarea"></el-input>
				</el-form-item>
				<el-form-item label="支付宝私钥">
					<el-input v-model="alipayParam.alipay_private_key" type="textarea"></el-input>
				</el-form-item>
				<el-button @click='modifyAlipay'>提交</el-button>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="wxShow" title='修改微信支付参数'>
			<el-form label-position='left' ref="form3" :model="wxParam" label-width="200px" size="mini">
				<el-form-item label="app id">
					<el-input v-model="wxParam.wechat_app_id"></el-input>
				</el-form-item>
				<el-form-item label="微信商户号">
					<el-input v-model="wxParam.wechat_mch_id"></el-input>
				</el-form-item>
				<el-form-item label="微信api_key_v1">
					<el-input v-model="wxParam.wechat_api_key" type="password"></el-input>
				</el-form-item>
				<el-button @click='modifyWx'>提交</el-button>
			</el-form>
			
		</el-dialog>
	</div>
</template>

<script>
import {
	mapActions, mapState 
} from "vuex";
import {
	modifyApp,
	modifyWxParams,
	modifyAlipayParams
} from "../api/index.js"
export default {
	data() {
		return {
			priceAndTelShow:false,
			alipayShow:false,
			wxShow:false,
			alipayParam:{
				alipay_app_id:'',
				alipay_public_key:'',
				alipay_private_key:''
			},
			wxParam:{
				wechat_app_id:'',
				wechat_mch_id:'',
				wechat_api_key:''
			},
			temp_ele_price:0,
			temp_clothes_price:0
		}
	},
	computed:{
		...mapState([
			"app_info",
		]),
		H5_link(){
			return 'https://www.id-photo-verify.com/edu/index.html?key='+this.app_info.webapp_key
		}
	},
	
	mounted() {
		this.copyBtn = new this.clipboard(this.$refs.copy);
	},
	methods:{
		...mapActions([
			"getAppInfoFromServer"
		]),
		copyCode:function(){
			let _this = this;
			let clipboard = _this.copyBtn;
			clipboard.on('success', function() {
				_this.$message({ 
					message: '复制成功！',
					type: 'success'
				});
			});
			clipboard.on('error', function() {
				_this.$message({
					message: '复制失败，请手动选择复制！',
					type: 'error'
				});
			});
		},
		submit:function(){
			if(!this.temp_ele_price){
				this.$message.error('必须输入电子照价格！')
				return
			}
			if(isNaN(this.temp_ele_price)){
				this.$message.error('电子照价格必须是数字！')
				return
			}else{
				this.app_info.ele_price = parseFloat(this.temp_ele_price).toFixed(2).toString();
			}
			if(this.temp_clothes_price){
				if(isNaN(this.temp_clothes_price)){
					this.$message.error('证件照制作并换正装价格必须是数字！')
					return
				}else{
					this.app_info.clothes_price = parseFloat(this.temp_clothes_price).toFixed(2).toString();
				}
			}else{
				this.app_info.clothes_price = "0";
			}
			
			
			modifyApp(this.app_info).then(res=>{
				console.log(res)
				if(res.data.code==200){
					this.priceAndTelShow = false;
					this.afterModify();
				}
			})
		},
		modifyAlipay:function(){
			if(confirm("修改支付参数需谨慎，若填入参数有误，将导致用户无法支付！确认修改请点击确认")){
				modifyAlipayParams({...this.alipayParam,webapp_key:this.app_info.webapp_key}).then(res=>{
					if(res.data.code==200){
						this.alipayShow = false;
						this.afterModify();
					}
				})
			}
			
		},
		modifyWx:function(){
			if(confirm("修改支付参数需谨慎，若填入参数有误，将导致用户无法支付！确认修改请点击确认")){
				modifyWxParams({...this.wxParam,webapp_key:this.app_info.webapp_key}).then(res=>{
					if(res.data.code==200){
						this.wxShow = false;
						this.afterModify();
					}
				})
			}
		},
		afterModify:function(){
			this.$message({
				message: '修改成功',
				type: 'success'
			});
			this.getAppInfoFromServer().catch(err=>{
				console.log(err)
				this.$message.error('系统错误，请联系管理员')
			})
		}
	}
}
</script>

<style scoped="scoped">
	.row{
		margin: 10px 0;
	}
	.row>div:first-of-type{
		/* line-height: inherit; */
	}
	#setBasicInfo{
		margin:30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		border-radius: 10px;
		padding:20px 80px;
		font-size: 16px;
		font-weight: bold;
		color: #4C4C4C;
	}
	#code-div{
		width: 390px;
		height: 100px;
		background: #F4F4F4;
		border-radius: 6px;
		border: 1px solid #DDDDDD;
		padding: 10px;
		box-sizing: border-box;
		overflow: scroll;
		font-weight: 14px;
		color: #BEBEBE;
	}
	#copy-button{
		width: 86px;
		height: 36px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #287AFF;
		font-size: 12px;
		font-weight: bold;
		color: #287AFF;
		line-height: 36px;
		text-align: center;
		margin-top: 10px;
	}
</style>